import { energyFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Energy/energyFormParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationBeEnergy } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Energy/BE/contractSaveParametersGeneration'
import * as Sentry from '@sentry/react'
import { contractSaveParametersGeneration as contractSaveParametersGenerationBeTelecom } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Telecom/BE/contractSaveParametersGeneration'
import { contractSaveParametersGeneration as contractSaveParametersGenerationBeInsurance } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Insurance/BE/contractSaveParametersGeneration'
import { insuranceFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Insurance/insuranceFormParametersGeneration'
import { telecomFormParametersGeneration } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Contract/Telecom/telecomFormParametersGeneration'

const parametersGeneratorByCountryAndVertical = {
  'be-energy': contractSaveParametersGenerationBeEnergy,
  'be-insurance': contractSaveParametersGenerationBeTelecom,
  'be-telecom': contractSaveParametersGenerationBeInsurance,
  'fr-energy': energyFormParametersGeneration,
  'fr-insurance': insuranceFormParametersGeneration,
  'fr-telecom': telecomFormParametersGeneration,
  'nl-energy': energyFormParametersGeneration,
}

export function generateParameters({
  type,
  country,
  contractId,
  contactId,
  addressId,
  contractData,
  characteristicsData,
  clientPreferences,
  action,
  contractAddressData,
  electricityMeterData,
  gasMeterData,
  propaneData,
  billingData,
  energyConsumptionData,
}) {
  const generatorKey = `${country}-${type}`
  const generator = parametersGeneratorByCountryAndVertical[generatorKey] ?? null

  if (generator) {
    return generator({
      type,
      contractId,
      contactId,
      addressId,
      contractData,
      characteristicsData,
      mainAddressData: contractAddressData,
      clientPreferences,
      electricityMeterData,
      billingData,
      gasMeterData,
      energyConsumptionData,
      action,
      propaneData,
    })
  }

  if (import.meta.env.PROD) {
    Sentry.captureException(new Error(`generateParameters: Unknown business vertical type '${type}'`), {
      extra: { type },
    })
  }
  throw new Error(`generateParameters: Unknown business vertical type '${type}'`)
}
